import React, { useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import clsx from 'clsx';
import { ArticleCategoryModel } from '../Types/ArticleCategoryModel';

interface PageListFilterProps {
  categories: ArticleCategoryModel[];
  onChange: (activeFilters: string[]) => void;
  activeTagIds: string[];
  setActiveTagIds: any
}

const PageListFilter = ({
  categories,
  onChange,
  activeTagIds,
  setActiveTagIds
}: PageListFilterProps) => {
  
  const addFilterToList = (tagId: string) => {
    let newTagIdsList: string[] = [];
    if (!activeTagIds.includes(tagId)) {
      newTagIdsList = [...activeTagIds, tagId];
    } else {
      const listExcludingTagId = activeTagIds.filter(
        (existingTagId) => existingTagId != tagId
      );
      newTagIdsList = listExcludingTagId;
    }

    if (typeof onChange === 'function') {
      onChange(newTagIdsList);
    }

    setActiveTagIds(newTagIdsList);
  };

  const clearTagIds = () => {
    if (activeTagIds.length == 0) return;

    if (typeof onChange === 'function') {
      onChange([]);
    }

    setActiveTagIds([]);
  };

  return (
    <div className="mb-6 mt-10 lg:px-4">
      <div className="nowrap flex flex-row gap-4 overflow-x-auto [&_>span]:relative [&_>span]:pb-px [&_>span]:after:absolute [&_>span]:after:bottom-0 [&_>span]:after:left-0 [&_>span]:after:right-0 [&_>span]:after:h-0.5 [&_>span]:after:bg-gray-900  [&_>span]:after:transition-opacity [&_>span]:after:duration-500 ">
        <span
          className={clsx(
            'h4 ml-4 cursor-pointer whitespace-nowrap font-normal text-gray-700 after:opacity-0 hover:after:opacity-100 lg:ml-0',
            activeTagIds.length == 0 && 'after:opacity-100'
          )}
          onClick={clearTagIds}
        >
          {translate('general.show-all')}
        </span>
        {categories &&
          categories.length > 0 &&
          categories.map((category, idx) => (
            <span
              className={clsx(
                'h4 cursor-pointer whitespace-nowrap font-normal text-gray-700 after:opacity-0 last:mr-4 hover:after:opacity-100 lg:last:mr-0',
                activeTagIds.includes(category.tagId) &&
                  'after:opacity-100'
              )}
              onClick={() => addFilterToList(category.tagId)}
              key={category.name + idx}
            >
              {category.name}
            </span>
          ))}
      </div>
    </div>
  );
};

export default PageListFilter;
